
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gov/[chain]/[[...slug]]",
      function () {
        return require("private-next-pages/gov/[chain]/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gov/[chain]/[[...slug]]"])
      });
    }
  